export default __webpack_public_path__ + "images/2_habitat.jpg";